module.exports = __webpack_public_path__ + "static/img/first-win.c70ec0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/first-win.png
// module id = A/i3
// module chunks = 0